export const sizeRequest = ({
    name,
    description,
    active
} = {}) => ({
    name,
    description,
    active
})